<template>
    <div>
        <div class="card-body" style="height: 250px;">
            <el-form label-width="90px" :label-position="'right'">
                <el-row :gutter="10">
                    <el-form-item label="年级:">
                        <el-select v-model="$parentInfo.distributionStudent.grades_id"
                                   multiple
                                   clearable
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in $parentInfo.distributionStudent.grades"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row :gutter="10">
                    <el-form-item label="学校:">
                        <el-select v-model="$parentInfo.distributionStudent.school_id"
                                   filterable remote
                                   clearable
                                   placeholder="请选择"
                                   :remote-method="handleSearchSchool">
                            <el-option
                                    v-for="item in $parentInfo.distributionStudent.schools"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row :gutter="10">
                    <el-form-item label="学期:">
                        <el-select v-model="$parentInfo.distributionStudent.semesters_id"
                                   multiple
                                   clearable
                                   placeholder="请选择"
                            >
                            <el-option
                                    v-for="item in $parentInfo.distributionStudent.semesters"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row :gutter="10">
                    <el-form-item label="班主任:">
                        <el-select v-model="$parentInfo.distributionStudent.headTeacher_id"
                                   filterable remote
                                   clearable
                                   placeholder="请选择"
                                   :remote-method="handleSearchHeadTeacher">
                            <el-option
                                    v-for="item in $parentInfo.distributionStudent.headTeachers"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <div style="text-align: right">
            <el-button type="primary" size="small" @click="handleGive()" v-loading="$parentInfo.distributionStudent.loading">确 定</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DistributionStudent",
        data() {
            return {

            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleInit();
        },
        methods: {
            handleInit(){
                this.$wApi.send(this.$parentInfo.path, 'init_distribution_student', {
                    'employee_id': this.$store.state.modal.data.employee_id,
                });
            },
            handleSearchHeadTeacher(query){
                this.$wApi.send(this.$parentInfo.path, 'search', {
                    'type':'searchHeadTeacher',
                    'headTeacherKeyName': query,
                })
            },
            handleSearchSchool(query){
                this.$wApi.send(this.$parentInfo.path, 'search', {
                    'type':'searchSchool',
                    'schoolKeyName': query,
                })
            },
            handleGive(){
                this.$parentInfo.distributionStudent.loading=true;
                this.$wApi.send(this.$parentInfo.path, 'distribution_student', {
                    'choose_headTeacher_id':this.$parentInfo.distributionStudent.headTeacher_id,
                    'school_id':this.$parentInfo.distributionStudent.school_id,
                    'grades_id':this.$parentInfo.distributionStudent.grades_id,
                    'semesters_id':this.$parentInfo.distributionStudent.semesters_id,
                    'employee_id':this.$store.state.modal.data.employee_id,

                })
            },
        }
    }
</script>

<style scoped>
    .card-body{
        height: calc(100vh - 125px);
    }
    .card-footer{
        position: fixed;
        width: calc(100% - 20px);
        padding: 5px 10px;
        bottom: 0;
    }
</style>